export class Usef_person  {

	search_date: Date;
	id: string;
	entity_type: string;
	prefix: string;
	first_name: string;
	middle_name: string;
	last_name: string;
	suffix: string;
	name: string;
	date_of_birth: string;
	usef_age: number;
	gender: string;
	amateur_pro_status: string;
	us_citizen: boolean;
	suspension_status: string;
	breed_discipline: string;
	fei_reg_number: string;
	fei_registration_status: string;
	address1: string;
	address2: string;
	city: string;
	state: string;
	zip: string;
	country: string;
	email_address: string;
	uuid: string;
	safe_sport_training_expires_date: Date;
	background_check_expires_date: Date;
	memberships: Usef_membership[] = [];
	phone_numbers: Usef_phone[] = [];
  is_minor: boolean;

    constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}

export class Usef_membership {
	org_name: string;
	member_number: string;
	membership_type: string;
	member_start_date: Date;
	member_end_date: Date;
	status: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}


}

export class Usef_phone {
	type: string;
	number: string;

	constructor(values: Object = {}){
		Object.assign(this, values);
	}
}
